import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  EmptyFileList,
  StyledFileList,
  FileListHeader,
  Date,
  Rows,
  DevicesHeader,
  NetworksHeader,
  AiringsHeader,
  BrandsHeader,
  View,
  FileListItem,
  FileListItemContent,
  Devices,
  Networks,
  Airings,
  Brands,
  Country,
  PbseVersion,
  Titles,
  TitlesHeader
} from "./styles";
import { /* EllipseIcon */ ViewFileIcon } from "../../../../icons";
import { formatNum, formatDate } from "../../../../utils";
import FilePreviewModal from "./FilePreviewModal";

class FileList extends Component {
  state = {
    openFileId: null
  };

  render() {
    const { files, feed } = this.props;
    const { openFileId } = this.state;

    if (files.length === 0)
      return <EmptyFileList>No files have been processed yet</EmptyFileList>;

    return (
      <StyledFileList>
        <FileListHeader>
          <Date>Date</Date>
          <Rows># of Rows</Rows>
          <DevicesHeader># of Devices</DevicesHeader>
          <NetworksHeader># of Networks</NetworksHeader>
          {feed.type && feed.type.indexOf("viewership") < 0 ? (
            <>
              <AiringsHeader># of Airings</AiringsHeader>
              <BrandsHeader># of Brands</BrandsHeader>
            </>
          ) : (
            <TitlesHeader># of Titles</TitlesHeader>
          )}
          <Country>Country</Country>
          <PbseVersion>Pbse Version</PbseVersion>
          <View>View</View>
        </FileListHeader>
        {files.map(file => (
          <FileListItem key={file.id}>
            <FileListItemContent>
              <Date>{formatDate(file.day)}</Date>
              <Rows>{formatNum(file.row_cnt)}</Rows>
              <Devices>{formatNum(file.device_cnt)}</Devices>
              <Networks>{formatNum(file.network_cnt)}</Networks>
              {feed.type && feed.type.indexOf("viewership") < 0 ? (
                <>
                  <Airings>{formatNum(file.airing_cnt)}</Airings>
                  <Brands>{formatNum(file.brand_cnt)}</Brands>
                </>
              ) : (
                <Titles>{formatNum(file.title_cnt)}</Titles>
              )}
              <Country>
                <i
                  className={`flag-icon flag-icon-${feed.country.toLowerCase()}`}
                />
              </Country>
              <PbseVersion>{feed.pbse_version}</PbseVersion>
              <View onClick={() => this.setState({ openFileId: file.id })}>
                <ViewFileIcon />
              </View>
            </FileListItemContent>
          </FileListItem>
        ))}
        <FilePreviewModal
          file={files.find(file => file.id === openFileId)}
          show={!!openFileId}
          onDismiss={() => this.setState({ openFileId: null })}
        />
      </StyledFileList>
    );
  }
}

FileList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string,
      report_id: PropTypes.number,
      progressing: PropTypes.bool,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      row_cnt: PropTypes.string,
      device_cnt: PropTypes.string,
      network_cnt: PropTypes.string,
      airing_cnt: PropTypes.string,
      brand_cnt: PropTypes.string,
      sla_violation: PropTypes.bool
    })
  ),
  feed: PropTypes.object
};

export default FileList;
